import wrapWithProvider from './wrap-with-provider';
import wrapWithPersistGate from './wrap-with-persist-gate';
import 'unfetch/polyfill/index';
import smoothscroll from 'smoothscroll-polyfill';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

smoothscroll.polyfill();

export const onRouteUpdate = ({ location }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'optimize.activate' });

  if (process.env.NODE_ENV === 'development') {
    console.log('Route change:', location.pathname);
    // Fix the page not found in develop env
    const GATSBY_NAVIGATE = window.___navigate || {};
    window.addEventListener('popstate', () =>
      GATSBY_NAVIGATE(window.location.pathname, { replace: true })
    );
  }
  window.detoxAbortController && window.detoxAbortController.abort();
};

export const wrapPageElement = wrapWithPersistGate;
export const wrapRootElement = wrapWithProvider;
